import { computed } from "vue";

import { useAppConfig } from "@core/composables/data/useAppConfig";

interface Permissions {
  statistics: boolean;
  telemetry: boolean;
  applications: boolean;
  users: boolean;
  organizations: boolean;
  audits: boolean;
  remits: boolean;
  vehicleRegistry: boolean;
  manualApproval: boolean;
  trafficControl: boolean;
  system: boolean;
  camerasOverview: boolean;
  youparkTodos: boolean;
  youparkCustomerSubscriptionsRead: boolean;
  youparkSubscriptions: boolean;
  youparkInvoice: boolean;
  youpayAccounting: boolean;
  youparkFreeVisitRead: boolean;
  youparkAccounting: boolean;
  access: boolean;
  youparkSettings: boolean;
}

export function usePermissions() {
  const { config } = useAppConfig();

  const isEmployee = computed(() => config.isEmployee);
  const canAccessYouParkCustomer = computed(() => config.canAccessYouParkCustomer);
  const permissions = computed(() => config.permissions);
  const lots = computed(() => config.lots);

  return {
    isEmployee,
    canAccessYouParkCustomer,
    permissions,
    lots,
    hasPermission: (permission: keyof Permissions) => permissions.value[permission]
  };
}
